

export class InternFeeDto implements IInternFeeDto {
    id!: number;
    internId!: number;
    internName!: string | undefined;
    accountId!: number;
    accountName!: string | undefined;
    amount!: number;
    transactionDate!: Date;
    remarks!: string | undefined;

    constructor(data?: IInternFeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.internId = _data["internId"];
            this.internName = _data["internName"];
            this.accountId = _data["accountId"];
            this.accountName = _data["accountName"];
            this.amount = _data["amount"];
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : <any>undefined;
            this.remarks = _data["remarks"];
        }
    }

    static fromJS(data: any): InternFeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new InternFeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["internId"] = this.internId;
        data["internName"] = this.internName;
        data["accountId"] = this.accountId;
        data["accountName"] = this.accountName;
        data["amount"] = this.amount;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : <any>undefined;
        data["remarks"] = this.remarks;
        return data; 
    }
}

export interface IInternFeeDto {
    id: number;
    internId: number;
    internName: string | undefined;
    accountId: number;
    accountName: string | undefined;
    amount: number;
    transactionDate: Date;
    remarks: string | undefined;
}

